<template>
  <div>
    <b-row class="match-height">
      <b-col md="6">
        <advisors-stat :is-otm="false" />
      </b-col>
      <b-col md="6">
        <quarter-applicant-stat :is-otm="false" />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <edu-type-stat :is-otm="false" />
      </b-col>
      <b-col md="6">
        <doctorate-stat :is-otm="false" />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <direction-stat :is-otm="false" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import statisticModule from '@/store/statistic'
import AdvisorsStat from '@/views/org-stats/AdvisorsStat.vue'
import DirectionStat from '@/views/org-stats/DirectionStat.vue'
import DoctorateStat from '@/views/org-stats/DoctorateStat.vue'
import EduTypeStat from '@/views/org-stats/EduTypeStat.vue'
import QuarterApplicantStat from '@/views/org-stats/QuarterApplicantStat.vue'

export default {
  components: {
    QuarterApplicantStat,
    EduTypeStat,
    DoctorateStat,
    DirectionStat,
    AdvisorsStat,
    BRow,
    BCol,
  },
  setup() {
    const MODULE_NAME = 'statistic'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, statisticModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    return {
      MODULE_NAME,
    }
  },
}
</script>

<style>

</style>
